import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

interface QuantityCellProps {
  quantity: number | undefined;
  isCorrection?: boolean;
  readOnly?: boolean;
  onChange: (quantity: number) => void;
}

export const QuantityCell: React.FC<QuantityCellProps> = ({
  quantity,
  isCorrection,
  readOnly,
  onChange,
}) => {
  const [raw, setRaw] = useState(String(quantity ?? 1));

  useEffect(() => {
    setRaw(String(quantity ?? 1));
  }, [quantity]);

  const commit = (value: string) => {
    const parsed = parseInt(value, 10);
    const clamped = isNaN(parsed)
      ? 1
      : isCorrection
        ? parsed
        : Math.max(0, parsed);
    setRaw(String(clamped));
    onChange(clamped);
  };

  return (
    <Form.Control
      className="d-grid mb-2 mt-2"
      type="number"
      value={raw}
      onChange={e => commit(e.target.value)}
      disabled={readOnly}
    />
  );
};
